import { createFileRoute } from "@tanstack/react-router";
import { CreateFacturePage } from "@/features/achats/components/factures/CreateFacturePage";

export const Route = createFileRoute("/_app/achats/factures/create")({
  staticData: {
    title: "Nouvelle facture",
    showInBreadcrumb: true,
  },
  component: CreateFacturePage,
});
